/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import ControlFlip from 'solis/claude/element/zone/control/flip';
import ControlStatus from 'solis/claude/element/zone/control/status';

import Time from 'solis/time';

import { formatCompactDuration } from 'solis/claude/util/duration';


const hasFlip = (timeline) =>
{
  return timeline.getFlipDate() !== null;
};


const getCountdown = (timeline, now) =>
{
  return hasFlip(timeline) ? formatCompactDuration(timeline.getFlipDate() - now) : null;
};


const isFlipChanged = ({ zoneTimeline, originalTimeline, previousDate }, now) =>
{
  return previousDate === null && getCountdown(originalTimeline, now) !== getCountdown(zoneTimeline, now);
};


const FlipOrStatus = ({ timeline, ...props }) =>
{
  return hasFlip(timeline) ? <ControlFlip {...props} zoneTimeline = {timeline} /> : <ControlStatus {...props} zoneTimeline = {props.originalTimeline} required />;
};


const StatusAndFlip = (props) =>
(
  <>
    <ControlStatus {...props} zoneTimeline = {props.originalTimeline} />
    <ControlFlip {...props} />
  </>
);


const FlipChange = (props) =>
(
  <>
    <FlipOrStatus {...props} timeline = {props.originalTimeline} />
    <FlipOrStatus {...props} timeline = {props.zoneTimeline} mark = '→' />
  </>
);


export default (props) =>
{
  const now = use(Time);

  return isFlipChanged(props, now) ? <FlipChange {...props} /> : <StatusAndFlip {...props} />;
};
